export default __webpack_public_path__ + "static/media/cupboard.bf2eacf0.png";